module.exports = __webpack_public_path__ + "static/media/default-6.72f93e9a.svg";